import { Component, ElementRef, ChangeDetectorRef } from '@angular/core'
import { ContextService } from '../../services'
import { TranslateService } from '@ngx-translate/core'

@Component({
  standalone: false,
  selector: 'app-map-click-popup',
  templateUrl: './map-click-popup.component.html',
  styleUrls: ['./map-click-popup.component.scss'],
})
export class MapClickPopupComponent {
  stats: any = {}
  data: any = {}
  loading = true
  currentTab = ''
  selectedStats: any = {}
  tabs = []
  compareMode = false

  constructor(
    public elRef: ElementRef,
    private changeDetectorRef: ChangeDetectorRef,
    private context: ContextService,
    private translate: TranslateService,
  ) {}

  get isVisitsAvailable() {
    return this.context.isVisitsAvailable()
  }

  get title() {
    return this.data.properties.name || `#${this.data.properties.id}`
  }

  getExtra() {
    return this.context.keyIndicatorOptions
      .filter(
        (key) =>
          this.data.properties[key.value] !== null &&
          this.data.properties[key.value] !== undefined,
      )
      .map((key) => {
        return {
          value:
            this.data.properties[key.value] +
            this.data.properties[key.value + '_other'],
          label: this.translate.instant(key.label),
        }
      })
  }

  getSelectedStats() {
    if (this.selectedStats[this.currentTab] === undefined) {
      return []
    }
    if (this.selectedStats[this.currentTab] instanceof Array) {
      return this.selectedStats[this.currentTab]
    }

    return [this.selectedStats[this.currentTab]]
  }

  getStats() {
    return this.stats[this.currentTab]
  }
}
